module.exports = __webpack_public_path__ + "static/media/img_groceries.a13b1d9f.png";